import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController, MenuController, Events } from 'ionic-angular';
import { User } from '@providers/advance_providers';

import { HomePage } from '../';

@Component({
  selector: 'page-login',
  templateUrl: 'page.html'
})
export class LoginPage {

  form={
    username:'',
    password:''
  };
  loading:any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private menuCtrl: MenuController,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public events: Events,
    public userApi: User
  ) {

  }

  ionViewWillEnter() {
    if(localStorage.form_login!=undefined){
      this.doLogin(1);
    }else{
      localStorage.clear();
      this.menuCtrl.enable(false, 'MainMenu');
    }
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  doLogin(check=0){
    this.showLoading();

    if(check){
      this.form = JSON.parse(localStorage.form_login);
    }
    let params = this.form;

    this.userApi.login(params).subscribe((resp:any) => {
      this.presentToast(resp.msg);
      this.loading.dismiss();
      if(resp.success){
        localStorage.is_login=1;
        localStorage.form_login=JSON.stringify(this.form);
        localStorage.data_user=JSON.stringify(resp);
        this.setSession();
        this.menuCtrl.enable(true, 'MainMenu');
        this.navCtrl.push(HomePage);
      }
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });    
  }

  setSession(){
    let resp = JSON.parse(localStorage.data_user);

    this.userApi.is_login=1;
    this.userApi.data=resp.data;
    this.userApi.group = resp.group;
    let group_user_data = JSON.parse(resp.group.user_data);
    let akses = {};
    resp.fitur.forEach(rec => {
      akses[rec.fitur_app] = true;
      akses[rec.fitur_app+"_fitur_data"] = rec.fitur_data;
      akses[rec.fitur_app+"_group_data"] = rec.group_data;
      if(rec.group_data=='fitur_user_data' && group_user_data[rec.fitur_app]!=undefined){
          akses[rec.fitur_app+"_user_data"] = group_user_data[rec.fitur_app];
      }
    });
    this.userApi.akses = akses;
    this.events.publish('user:sign_in', resp);
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/advance_mobile/login/page.ts